module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-8"
    }
  }, [_c('h1', {
    staticClass: "toctitle"
  }, [_vm._v("CONTENTS")])]), _c('h2', {
    staticClass: "tocfd"
  }, [_c('a', {
    attrs: {
      "id": "VPS-8"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/007_Foreword"
    }
  }, [_vm._v("Foreword: “Herb Kohl: Poet Laureate of Teaching” by William Ayers")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocfd_1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/008_Acknowledgements"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocfd_2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toclf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/009_Chapter_1"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Part I:")]), _vm._v(" Becoming a Teacher")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_2"
    }
  }, [_vm._v("“The Tattooed Man: Confessions of a Hopemonger” from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“I Won’t Learn from You”: And Other Thoughts on Creative Maladjustment")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Beginning to Teach” from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Growing Minds: On Becoming a Teacher")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpt from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("36 Children")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Fresh Waters Are Ever Flowing” from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Discipline of Hope: Learning from a Lifetime of Teaching")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toclf1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Part II: ")]), _vm._v(" Teaching and Learning")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Six Basic Skills” from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Basic Skills: A Plan for Your Child, a Program for All Children")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/016_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Why Teach?” from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("On Teaching")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/017_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Excerpt from Reading, How To")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/019_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“The Craft of Teaching” from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Growing Minds: On Becoming a Teacher")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-9"
    }
  }), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "VPS-9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/020_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Games and Maths” from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Writing, Maths, and Games in the Open Classroom")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toclf1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/021_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Part III: ")]), _vm._v("Being a Parent")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/022_Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpt from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Growing with Your Children")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/023_Chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpt from “On Being a Father”")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/024_Chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpt from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Painting Chinese")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toclf1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/025_Chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("Part IV: ")]), _vm._v(" Speculations on Education, Learning, and Politics")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/026_Chapter_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Creative Maladjustment and the Struggle for Public Education” from “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I Won’t Learn from You”: And Other Thoughts on Creative Maladjustment")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/027_Chapter_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Stupidity and Tears” from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stupidity and Tears: Teaching and Learning in Troubled Times")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/028_Chapter_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Topsy-Turvies: Teacher Talk and Student Talk” from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stupidity and Tears: Teaching and Learning in Troubled Times")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0